import { Injectable } from '@angular/core';

export interface TreeviewConfigParams {
    decoupleChildFromParent?: boolean,
    forceTooltip?: boolean,
    hasAllCheckBox?: boolean,
    hasBorder?: boolean,
    hasClearAllButton?: boolean,
    hasContainerLeftMargin?: boolean,
    hasCollapseExpand?: boolean,
    hasFilter?: boolean,
    hideClearButton?: boolean,
    label?: string,
    maxHeight?: number,
    notextFound?: string,
    showSearchIcon?: boolean,
    tooltip?: string,
    virtualScrollEnabled?: boolean,
    isParentToggleDisabled?: boolean,
    isAllToggleDisabled?: boolean,
}

@Injectable()
export class TreeviewConfig {
    forceTooltip: boolean = false;
    hasAllCheckBox: boolean = true;
    hasBorder: boolean = false;
    hasFilter: boolean = false;
    hasCollapseExpand: boolean = false;
    hasContainerLeftMargin: boolean = false;
    decoupleChildFromParent: boolean = false;
    maxHeight: number = 500;
    label: string = '';
    notextFound: string = '';
    hideClearButton: boolean = false;
    showSearchIcon: boolean = false;
    virtualScrollEnabled: boolean = false;
    hasClearAllButton: boolean = false;
    tooltip: string = '';
    isParentToggleDisabled: boolean = false;
    isAllToggleDisabled: boolean = false;

    get hasDivider(): boolean {
        return this.hasFilter || this.hasAllCheckBox || this.hasCollapseExpand;
    }

    public static create(fields?: TreeviewConfigParams): TreeviewConfig {
        const config: TreeviewConfig = new TreeviewConfig();
        Object.assign(config, fields);
        return config;
    }
}
